import { ONE_CUBIC_FEET } from 'helpers/constants';

export function calcInventoryTotal(list) {
  let quantity = 0;
  let total = 0;
  let cf = 0;

  list.forEach((el) => {
    quantity = quantity + Number(el.qty);
    total = total + Number(el.amount) * Number(el.qty);
    cf = cf + Number(el.amount);
  });

  const pounds = cf * ONE_CUBIC_FEET;

  return { quantity, total, cf, pounds };
}
